import { usePrepareStoredMagazine } from "./prepareStoredMagazine";
import { useBoundStore } from "../zustand/Store";
import { useRouter } from "expo-router";
import { Magazine } from "../Datatypes";

export const useHandleSelectMagazine = () => {
  const router = useRouter();
  const updateCurrentMagazine = useBoundStore((state) => state.updateCurrentMagazine);
  const updateCurrentPage = useBoundStore((state) => state.updateCurrentPage);
  const prepareStoredMagazine = usePrepareStoredMagazine();

  return async (magazine: Magazine) => {
    //console.log("useHandleSelectMagazine - magazine",magazine);
    //await prepareStoredMagazine(magazine);
    //magazine = {
    //  date: "20250413",
    //  edition: "SONNTAG"
    //}
    updateCurrentMagazine(magazine);
    updateCurrentPage(1);
    router.navigate(`../PDFViewer`);
  };
};